import { render } from "./LoadingSvg.vue?vue&type=template&id=68c90f9d&ts=true"
import script from "./LoadingSvg.vue?vue&type=script&lang=ts"
export * from "./LoadingSvg.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__